(() => {
  const initialize = () => {
    const pagination = document.getElementById('infinite-scroll-pagination');
    const productList = document.querySelector('.product-list');

    if (!pagination || !productList || !('IntersectionObserver' in window)) return;

    let nextPageUrl = pagination.dataset.nextPageUrl;
    let isLoading = false;
    const fallbackPagination = document.querySelector('.infinite-scroll__fallback');

    // Verberg de standaard pagination alleen wanneer infinite scroll werkt.
    if (fallbackPagination) fallbackPagination.hidden = true;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) loadNextPage();
      },
      // Laad de volgende pagina al ruim vóór de klant onderaan is.
      { rootMargin: '1200px 0px' }
    );

    const loadNextPage = async () => {
      if (isLoading || !nextPageUrl) return;

      isLoading = true;
      observer.unobserve(pagination);

      try {
        const response = await fetch(nextPageUrl, {
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error(`Request failed: ${response.status}`);
        }

        const page = new DOMParser().parseFromString(
          await response.text(),
          'text/html'
        );

const newProductList = page.querySelector('.product-list');
const newProducts = newProductList
  ? [...newProductList.children]
  : [];

if (!newProducts.length) {
  throw new Error('No product cards found on the next collection page.');
}

        productList.append(...newProducts);

        nextPageUrl =
          page.getElementById('infinite-scroll-pagination')?.dataset.nextPageUrl ||
          null;
      } catch (error) {
        console.error('Unable to load more products.', error);

        // Laat de normale pagination terugkomen als laden mislukt.
        if (fallbackPagination) fallbackPagination.hidden = false;
        nextPageUrl = null;
      } finally {
        isLoading = false;

        if (nextPageUrl) {
          requestAnimationFrame(() => observer.observe(pagination));
        }
      }
    };

    observer.observe(pagination);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();